import { css } from '@emotion/css'
import { spacing, borderRadius, zIndex, fontFamily, fontSize, fontWeight, colors, hexToRgba } from '@offerzen/pinata-shame'

const styles = {
  wrapper: css({
    boxSizing: 'border-box',
    position: 'relative',
  }),

  trigger: css({
    boxSizing: 'border-box',
    position: 'relative',
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    color: colors.white,
    cursor: 'pointer',
    userSelect: 'none',
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
  }),

  triggerOpen: css({
    zIndex: zIndex.level10,
  }),

  icon: css({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: spacing.extraSmall,
  }),

  body: css({
    boxSizing: 'border-box',
    position: 'absolute',
    top: `calc(100% - ${spacing.small}px)`,
    right: -spacing.medium,
    zIndex: zIndex.level10,
    listStyle: 'none',
    padding: 0,
    margin: 0,
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default,
    boxShadow: `0 0 4px 2px ${hexToRgba(colors.scorpion, 0.1)}`,
    backgroundColor: colors.white,
    minWidth: 150,
    fontSize: fontSize.default,
    lineHeight: 1.2,
    fontWeight: fontWeight.regular,

    '&::before': {
      content: '""',
      boxSizing: 'border-box',
      width: 12,
      height: 12,
      transform: 'rotate(45deg)',
      backgroundColor: colors.white,
      display: 'block',
      position: 'absolute',
      top: -7,
      right: 18,
      borderTop: `1px solid ${colors.mystic}`,
      borderLeft: `1px solid ${colors.mystic}`,
      zIndex: -1,
    },

    '& > *': {
      borderBottom: `1px solid ${colors.mystic}`,
    },

    '& > *:first-child': {
      borderTopLeftRadius: borderRadius.default,
      borderTopRightRadius: borderRadius.default,
    },

    '& > *:last-child': {
      borderBottomLeftRadius: borderRadius.default,
      borderBottomRightRadius: borderRadius.default,
      borderBottom: 0,
    },
  }),

  overlay: css({
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: zIndex.level9,
  }),
}

export default styles
